import { axiosInstance } from "../axiosConfig";

export default async function getPrices() {
  try {
    const { data } = await axiosInstance.get("/get_price");
    return data;
  } catch (err) {
    throw err;
  }
}
